import { MenuItemGroup } from 'element-ui'

const YMenuItemGroup = MenuItemGroup
YMenuItemGroup.$depends = [MenuItemGroup]
YMenuItemGroup.$name = 'y-menu-item-group'
YMenuItemGroup._name = 'MenuItemGroup 导航菜单组'

export default YMenuItemGroup
